export default __webpack_public_path__ + "static/media/aboutHz1.24f89be2.jpg";